import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { GalleryPageComponent } from './components/gallery-page/gallery-page.component';
import { GalleryListComponent } from './components/gallery-list/gallery-list.component';

const routes: Routes = [
  {
    path: '', component: GalleryPageComponent, data: { title: '' },
    children: [
      {
        path: '', component: GalleryListComponent, data: { title: '' }
      }    
    ]
  },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GalleryRoutingModule { }
